exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n\tposition: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/spinner/spinner.component.css
// module id = ../../../../../src/app/utilities/spinner/spinner.component.css
// module chunks = main